import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.vehicleSelectors;

export const getVehicleImageUrl = (state: any) => getRoot().getVehicleImageUrl(state);
export const getVehicleVin = (state: any) => getRoot().getVehicleVin(state);
